<template>
  <div class="taxId">
    <div class="tax-input">
      <VTextField
        v-model="taxId.value"
        :mask="taxMask"
        :rules="rules"
        :label="label"
        :hint="hint"
        :persistent-hint="persistentHint"
        :placeholder="placeholder"
        :return-masked-value="returnMaskedValue"
        validate-on-blur
        class="flex-column"
        required
        @input="$emit('input', taxId)"
        @blur="$emit('input', taxId)"
      ></VTextField>
    </div>
  </div>
</template>

<script>
/**
 * Original Author: Ben Layton
 * Original Team: Fore oh Four!
 */
import { VTextField } from 'vuetify/lib';
import { taxFormats } from './taxIdFormats.js';

export default {
  name: 'NsTaxId',
  components: {
    VTextField,
  },
  props: {
    /**
     * Field Label
     */
    fieldLabel: {
      type: String,
      default: '',
    },
    /**
     * Hint
     */
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
    /**
     * Invalid message
     */
    errorMessage: {
      type: String,
      default: '',
    },
    /**
     * Default country code
     */
    country: {
      type: String,
      default: 'AR',
    },
    /**
     * Default customer type
     */
    custType: {
      type: String,
      default: 'personal',
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      languageList: [],
      taxId: {
        value: '',
        serviceField: '',
        sapField: '',
      },
      maxLength: 10,
      taxMask: '',
      form: {},
      label: 'Tax ID',
      regex: '',
      rules: [
        (v) =>
          (!v && !this.required) ||
          v.length <= this.maxLength ||
          this.errorText,
        (v) => (!v && !this.required) || this.regex.test(v) || this.errorText,
        (v) =>
          (!v && !this.required) ||
          this.validationFunction(v) ||
          this.errorText,
      ],
      validationFunction: undefined,
      placeholder: '',
      taxIdValid: null,
      errorText: 'This field is required',
      returnMaskedValue: false,
    };
  },
  watch: {
    country() {
      this.updateTaxIdField(this.country, this.custType);
    },
    custType() {
      this.updateTaxIdField(this.country, this.custType);
    },
    fieldLabel() {
      this.updateTaxIdField(this.country, this.custType);
    },
  },
  created() {
    this.updateTaxIdField(this.country, this.custType);
    if (this.errorMessage !== '') {
      this.errorText = this.errorMessage;
    }
  },
  methods: {
    updateTaxIdField(country, custType) {
      const taxFormat = taxFormats[country][custType].taxInfo;
      this.label = this.fieldLabel !== '' ? this.fieldLabel : taxFormat.label;
      this.taxMask = taxFormat.format;
      this.regex = taxFormat.regex;
      this.maxLength = taxFormat.maxLength;
      this.taxId.serviceField = taxFormat.fieldInService;
      this.taxId.sapField = taxFormat.fieldInSAP;
      this.returnMaskedValue = taxFormat.returnMaskedValue;
      this.validationFunction = taxFormat.validationFunction || (() => true);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use '~@nuskin/ns-core-styles/src/scss/gridStyles';
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
</style>
